var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 0.299988C5.54868 0.299988 0.299805 5.54887 0.299805 12C0.299805 18.4511 5.54868 23.7 11.9998 23.7C18.4509 23.7 23.6998 18.4511 23.6998 12C23.6998 5.54887 18.4509 0.299988 11.9998 0.299988ZM11.9998 22.4C6.2655 22.4 1.5998 17.7343 1.5998 12C1.5998 6.26569 6.2655 1.59999 11.9998 1.59999C17.7341 1.59999 22.3998 6.26569 22.3998 12C22.3998 17.7343 17.7341 22.4 11.9998 22.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8997 11.35H12.6497V8.10001C12.6497 7.74048 12.3592 7.45001 11.9997 7.45001C11.6402 7.45001 11.3497 7.74048 11.3497 8.10001V11.35H8.09971C7.74018 11.35 7.44971 11.6405 7.44971 12C7.44971 12.3595 7.74018 12.65 8.09971 12.65H11.3497V15.9C11.3497 16.2595 11.6402 16.55 11.9997 16.55C12.3592 16.55 12.6497 16.2595 12.6497 15.9V12.65H15.8997C16.2592 12.65 16.5497 12.3595 16.5497 12C16.5497 11.6405 16.2592 11.35 15.8997 11.35Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRounded);
export default __webpack_public_path__ + "static/media/addRounded.d0dd8540311670954866009e08af42d3.svg";
export { ForwardRef as ReactComponent };